import Button from '@mui/material/Button';
import { onClickHandler } from './utilities/click_handler';
import colors from './colors';

export type SocialButtonProps = {
  type: 'google' | 'facebook' | 'instagram' | 'apple'
  onClick: () => void
};

const images: Record<SocialButtonProps['type'], string> = {
  apple: './assets/apple.png',
  facebook: './assets/facebook.png',
  google: './assets/google.png',
  instagram: './assets/instagram.png',
};

export const SocialButtonUI: React.FC<SocialButtonProps> = ({ type, onClick }) => {
  const imageUrl = images[type];
  return (
    <Button style={{ borderColor: colors.greige }} onClick={onClickHandler(onClick)} sx={{ width: '56px', height: '40px' }} variant="outlined">
      {/* <div style={{backgroundImage: imageUrl, width: '56px', height: '40px'}} /> */}
      <div style={{ backgroundImage: `url(${imageUrl})`, width: '24px', height: '24px' }} />
    </Button>
  );
};
